/**
 * Utility per gestire notifiche browser chat
 */

export interface ChatNotificationOptions {
  title: string;
  body: string;
  icon?: string;
  tag?: string;
}

/**
 * Richiede permesso notifiche browser
 */
export async function requestNotificationPermission(): Promise<boolean> {
  if (!('Notification' in window)) {
    console.warn('[Notifications] Browser non supporta notifiche');
    return false;
  }

  if (Notification.permission === 'granted') {
    return true;
  }

  if (Notification.permission === 'denied') {
    console.warn('[Notifications] Permesso notifiche negato');
    return false;
  }

  try {
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  } catch (error) {
    console.error('[Notifications] Errore richiesta permesso:', error);
    return false;
  }
}

/**
 * Mostra notifica browser
 */
export function showChatNotification(options: ChatNotificationOptions): Notification | null {
  console.log('[Notifications] showChatNotification chiamata:', {
    hasNotification: 'Notification' in window,
    permission: Notification.permission,
    title: options.title,
    body: options.body
  });

  if (!('Notification' in window)) {
    console.warn('[Notifications] ❌ Browser non supporta Notification API');
    return null;
  }

  if (Notification.permission !== 'granted') {
    console.warn('[Notifications] ❌ Permesso notifiche non concesso:', Notification.permission);
    return null;
  }

  try {
    console.log('[Notifications] 🔔 Creazione notifica...');
    const notification = new Notification(options.title, {
      body: options.body,
      icon: options.icon || '/assets/logos/dialogicom-192x192.png',
      tag: options.tag || 'chat-message',
      requireInteraction: false,
      silent: false,
      badge: '/assets/logos/dialogicom-192x192.png',
    });

    console.log('[Notifications] ✅ Notifica creata con successo');

    // Click handler - apri/focus web app
    notification.onclick = () => {
      console.log('[Notifications] 👆 Click su notifica');
      window.focus();
      notification.close();
    };

    // Auto-close dopo 8 secondi
    setTimeout(() => notification.close(), 8000);

    return notification;
  } catch (error) {
    console.error('[Notifications] ❌ Errore creazione notifica:', error);
    return null;
  }
}

/**
 * Verifica se notifiche sono abilitate
 */
export function areNotificationsEnabled(): boolean {
  return 'Notification' in window && Notification.permission === 'granted';
}
